import React from 'react';

const CITIES = [
  {
    name: 'Atlanta',
    url: 'https://images.pexels.com/photos/33133726/pexels-photo-33133726.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    gridSpan: 'col-span-1 md:col-span-2 row-span-2'
  },
  {
    name: 'New York City',
    url: 'https://images.unsplash.com/photo-1643920771475-1097baab283f?crop=entropy&cs=srgb&fm=jpg&q=85',
    gridSpan: 'col-span-1 md:col-span-1 row-span-1'
  },
  {
    name: 'Los Angeles',
    url: 'https://images.unsplash.com/photo-1629946554503-d06fe7067560?crop=entropy&cs=srgb&fm=jpg&q=85',
    gridSpan: 'col-span-1 md:col-span-1 row-span-2'
  },
  {
    name: 'Philadelphia',
    url: 'https://images.pexels.com/photos/31500010/pexels-photo-31500010.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    gridSpan: 'col-span-1 md:col-span-2 row-span-1'
  },
  {
    name: 'Toronto',
    url: 'https://images.unsplash.com/photo-1707354241113-979c6fd14f84?crop=entropy&cs=srgb&fm=jpg&q=85',
    gridSpan: 'col-span-1 md:col-span-1 row-span-1'
  },
  {
    name: 'Montreal',
    url: 'https://images.pexels.com/photos/12953733/pexels-photo-12953733.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    gridSpan: 'col-span-1 md:col-span-2 row-span-1'
  }
];

const CityGrid = ({ onCitySelect, selectedCity }) => {
  const handleCityClick = (cityName, event) => {
    // Prevent default to avoid double-firing on mobile
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (onCitySelect && typeof onCitySelect === 'function') {
      onCitySelect(cityName);
    }
  };

  const handleTouchEnd = (cityName, event) => {
    // Handle touch events for mobile browsers
    event.preventDefault();
    handleCityClick(cityName, event);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 auto-rows-[200px]">
      {CITIES.map((city) => (
        <button
          key={city.name}
          type="button"
          className={`city-card ${city.gridSpan} ${selectedCity === city.name ? 'ring-4 ring-accent' : ''}`}
          onClick={(e) => handleCityClick(city.name, e)}
          onTouchEnd={(e) => handleTouchEnd(city.name, e)}
          onKeyPress={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleCityClick(city.name, e);
            }
          }}
          aria-label={`Select ${city.name} for tour signup`}
          data-testid={`city-card-${city.name.toLowerCase().replace(/\s+/g, '-')}`}
        >
          <img
            src={city.url}
            alt={city.name}
            className="w-full h-full object-cover grayscale-hover pointer-events-none"
            draggable="false"
          />
          <div className="city-card-overlay pointer-events-none">
            {city.name}
          </div>
        </button>
      ))}
    </div>
  );
};

export default CityGrid;